/* eslint-disable max-lines-per-function */
import React from "react";
import { AdType, ButtonType } from "../../../models";
import styles from "./DeletedCard.scss";

const DeletedCard = ({ ad, defaultButtons, onContainerClick, adCardProps }) => {
  const getAdTitle = () => {
    return `${ad.title ? `${ad.title} - ` : ""}${
      "Ovaj oglas nije aktivan"
    }`;
  };

  const buttonComponents = [...defaultButtons];

  const createButton = (role: any, containerclassName: any, type: any) => {
    const buttonMeta = buttonComponents.find(
      b => b.role === role && b.type === type
    );

    if (!buttonMeta) {
      return null;
    }

    const {
      style,
      component: ButtonComponent,
      props: { onClick, propsCompose, ...rest }
    } = buttonMeta;

    return (
      <span
        role="button"
        tabIndex={0}
        className={style || containerclassName}
        onClick={onContainerClick}
      >
        <ButtonComponent
          {...rest}
          {...(propsCompose ? propsCompose(adCardProps) : {})}
          onClick={onClick ? () => onClick(ad.id) : undefined}
        />
      </span>
    );
  };

  return (
    <div className={styles.title}>
      {getAdTitle()}
      {createButton(ButtonType.top, styles.deleteButton, AdType.inActive)}
    </div>
  );
};

export default DeletedCard;



// WEBPACK FOOTER //
// ./src/components/AdCard/DeletedCard/DeletedCard.tsx